export const enum RugbyUnionSubParticipantStatId {
  YellowCards = 8,
  RedCards = 9,
  PointsScored = 595,
  Tries = 400,
  Conversions = 402,
  ConversionsMissed = 1647,
  ConversionAttempts = 1648,
  PenaltyKickGoals = 1649,
  PenaltyKicksMissed = 1650,
  DropGoals = 401,
  DropGoalsMissed = 1652,
  OrangeCards = 1675,
  Appearance = 35,
  FirstLineups = 36,
}
